import {
  SET_PRODUCTS,
  SET_SUBPRODUCTS,
  SET_SUBPRODUCTSNEWS,
  SET_SUBPRODUCTS_DETAIL,
  SET_KEYWORD,
  SET_TAG,
} from '@/stores/constants';
import {
  getProducts,
  getSubProducts,
  getSubProductsComposer,
  getSubProductsNews,
  getSubProductDetail,
  getSubProductsByName,
  getTags,
} from '@/services/product';

export default {
  namespaced: true,
  state: {
    products: [],
    subproducts: [],
    subproductsnews: [],
    subproduct: {},
    keyword: '',
    tags: [],
  },
  getters: {
    getProducts: state => state.products,
    getSubProducts: state => state.subproducts,
    getSubProductsNews: state => state.subproductsnews,
    getSubProductDetail: state => state.subproduct,
    getKeyword: state => state.keyword,
    getTags: state => state.tags,
  },
  mutations: {
    [SET_PRODUCTS](state, products) {
      state.products = products;
    },
    [SET_SUBPRODUCTS](state, subproducts) {
      state.subproducts = subproducts;
    },
    [SET_SUBPRODUCTSNEWS](state, subproductsnews) {
      state.subproductsnews = subproductsnews;
    },
    [SET_SUBPRODUCTS_DETAIL](state, subproduct) {
      state.subproduct = subproduct;
    },
    [SET_KEYWORD](state, keyword) {
      state.keyword = keyword;
    },
    [SET_TAG](state, tags) {
      state.tags = tags;
    }
  },
  actions: {
    setKeyword ({ commit }, keyword) {
      commit(SET_KEYWORD, keyword)
    },
    async fetchProducts({ commit }) {
      const result = await getProducts();
      const { data } = result.data;
      commit(SET_PRODUCTS, data);
    },
    async fetchSubProducts({ commit }, id) {
      const result = await getSubProducts(id);
      const { data } = result.data;
      commit(SET_SUBPRODUCTS, data);
    },
    async fetchSubProductsComposer({ commit }, {id, page}) {
      const result = await getSubProductsComposer(id, page);
      const { data , included , meta } = result.data;
      commit(SET_SUBPRODUCTS, { data , included , meta });
    },
    async fetchSubProductsNews({ commit }) {
      const result = await getSubProductsNews();
      const { data } = result.data;
      commit(SET_SUBPRODUCTSNEWS, data);
    },
    async fetchSubProductsByName({ commit }, name) {
      const result = await getSubProductsByName(name);
      const { data , included } = result.data;
      commit(SET_SUBPRODUCTS, { data , included });
    },
    async fetchSubProductDetail({ commit }, id) {
      const result = await getSubProductDetail(id);
      const { data , included } = result.data;
      commit(SET_SUBPRODUCTS_DETAIL, { data , included });
    },
    async fetchTags({ commit }, id) {
      const result = await getTags(id);
      const { data , included } = result.data;
      commit(SET_TAG, { data , included });
    },
  },
};
